import PropTypes from 'prop-types';
import { getTourRateNameWithoutAge } from '../../../../../helpers/getTourRateAge';
import buildTourRateQuantities from '../../../../../helpers/buildTourRateQuantities';

const TourSingleRateSelect = ({
  rates,
  pickedRate,
  value,
  minQuantity,
  maxQuantity,
  onRateChange,
  onChange,
}) => {
  const rate = rates.find((entry) => (entry.parameterName || entry.name) === pickedRate);
  const counts = buildTourRateQuantities(rate, value, minQuantity, maxQuantity);

  return (
    <div className="flex items-center justify-between py-1 gap-3">
      <select
        className="border rounded px-2 py-0.5 min-w-0 flex-1"
        value={pickedRate}
        onChange={(event) => onRateChange(event.target.value)}
      >
        <option value="">Select an option</option>
        {rates.map((entry) => (
          <option key={entry.parameterName || entry.name} value={entry.parameterName || entry.name}>
            {getTourRateNameWithoutAge(entry)}
          </option>
        ))}
      </select>
      <select
        className="border rounded px-2 py-0.5 w-16 flex-shrink-0"
        value={value}
        disabled={!pickedRate}
        onChange={(event) => onChange(pickedRate, Number.parseInt(event.target.value, 10))}
      >
        <option value={0}>-</option>
        {counts.map((count) => (
          <option key={count} value={count}>
            {count}
          </option>
        ))}
      </select>
    </div>
  );
};

TourSingleRateSelect.propTypes = {
  rates: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  pickedRate: PropTypes.string,
  value: PropTypes.number,
  minQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
  onRateChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

TourSingleRateSelect.defaultProps = {
  pickedRate: '',
  value: 0,
  minQuantity: null,
  maxQuantity: null,
};

export default TourSingleRateSelect;
